import PropTypes from "prop-types"

export default {
  hasError: PropTypes.bool,
  key: PropTypes.string,
  params: PropTypes.object
}
